import {
  formatPhone,
} from '@/utils/string';

export type PatientAppointmentChangeBlockedReason = 'cutoff_reached' | 'appointment_started';

export type PatientAppointmentChangeBlockedResponse = {
  code: 'patient_appointment_change_blocked';
  reason: PatientAppointmentChangeBlockedReason;
  message: string;
  cutoffHours?: number | null;
  organizationName: string;
  organizationPhoneNumber?: string | null;
};

export function isPatientAppointmentChangeBlockedResponse(
  value: unknown,
): value is PatientAppointmentChangeBlockedResponse {
  if (typeof value !== 'object' || value === null) return false;

  const response = value as Partial<PatientAppointmentChangeBlockedResponse>;
  return response.code === 'patient_appointment_change_blocked'
    && (response.reason === 'cutoff_reached' || response.reason === 'appointment_started')
    && typeof response.message === 'string';
}

export function getPatientAppointmentChangeBlockedMessage(
  response: PatientAppointmentChangeBlockedResponse,
): string {
  if (!response.organizationPhoneNumber) return response.message;

  const formattedPhone = formatPhone(response.organizationPhoneNumber);
  return formattedPhone !== '--'
    ? `${response.message} Call ${formattedPhone}.`
    : response.message;
}
